import { Button, Form, Input, Popover, theme } from "antd";
import React, { useEffect, useState } from "react";
import {
    DislikeFilled,
    DislikeOutlined,
    LikeFilled,
    LikeOutlined,
    SearchOutlined,
} from "@ant-design/icons";
import { useUpdateItem } from "../../_actions/mutations/items";
import { useQuery } from "react-query";
import { secureAxios } from "../../_helpers/auth";
import { queryClient } from "../../_helpers/query";

const { TextArea } = Input;

function CanvasFeedbackBar({ history_id, entry_id, inline = false }) {
    const collection_name = history_id
        ? "qdb_creation_history"
        : "qdb_calendar_entries";
    const item_id = history_id || entry_id;

    const { isLoading, isSuccess, data } = useQuery(
        ["CanvasFeedbackBar", collection_name, item_id],
        () =>
            secureAxios
                .get(
                    `/items/${collection_name}/${item_id}?fields=id,liked,remark`,
                )
                .then((res) => res.data),
        {
            enabled: !!item_id,
            staleTime: 5 * 60 * 1000, // 5 minutes to prevent infinite refetching
        },
    );
    const [open_remark, setOpenRemark] = useState(false);
    const [remark, setRemark] = useState("");
    const mutation = useUpdateItem(collection_name, item_id, () => {
        queryClient.invalidateQueries([
            "CanvasFeedbackBar",
            collection_name,
            item_id,
        ]);
        // setOpenRemark(false);
        if (remark?.length > 0) {
            setRemark("");
            setOpenRemark(false);
        }
    });

    const { token } = theme.useToken();
    const liked = data?.liked === true;
    const disliked = data?.liked === false;

    useEffect(() => {
        if (open_remark) {
            mutation.mutate({
                liked: false,
            });
        }
    }, [open_remark]);

    if (!history_id && !entry_id) {
        return <></>;
    }

    return (
        <div
            style={
                inline
                    ? {
                          display: "flex",
                          flexDirection: "row",
                          gap: "5px",
                      }
                    : {
                          position: "absolute",
                          bottom: 10,
                          left: 0,
                          display: "flex",
                          flexDirection: "row",
                          gap: "5px",
                      }
            }
        >
            <Button
                shape="circle"
                icon={
                    liked ? (
                        <LikeFilled style={{ color: token.colorSuccess }} />
                    ) : (
                        <LikeOutlined />
                    )
                }
                loading={mutation.isLoading}
                onClick={() => {
                    mutation.mutate({
                        liked: liked ? null : true,
                    });
                }}
            />

            <Popover
                content={
                    <Form layout="vertical">
                        <Form.Item name="remark">
                            <TextArea
                                rows={4}
                                placeholder="Remark"
                                value={remark}
                                onChange={(e) => {
                                    setRemark(e.target.value);
                                }}
                            />
                        </Form.Item>
                        <Button
                            onClick={() => {
                                mutation.mutate({
                                    remark: remark,
                                });
                            }}
                            loading={mutation.isLoading}
                        >
                            Submit
                        </Button>
                    </Form>
                }
                title="Submit feedback"
                trigger="click"
                open={open_remark}
                onOpenChange={setOpenRemark}
            >
                <Button
                    shape="circle"
                    icon={
                        disliked ? (
                            <DislikeFilled
                                style={{ color: token.colorError }}
                            />
                        ) : (
                            <DislikeOutlined />
                        )
                    }
                    onClick={() => {
                        mutation.mutate({
                            liked: false,
                        });
                        setOpenRemark(true);
                    }}
                />
            </Popover>
        </div>
    );
}

export default CanvasFeedbackBar;
